import { useEffect, useRef } from 'react';
import Volanta from '@/components/Volanta';
import Image from 'next/image';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import useMediaQuery from '@/hooks/useMediaQuery';

gsap.registerPlugin(ScrollTrigger);

const SomosDesktop = ({ text: description }) => {
  const section = useRef(null);
  const isMobile = useMediaQuery('max-width: 650px');

  useEffect(() => {
    if (!section.current) return;

    const ctx = gsap.context(() => {
      if (isMobile) {
        const tl = gsap
          .timeline({
            scrollTrigger: {
              trigger: section.current,
              start: 'top top',
              end: 'bottom bottom',
              scrub: true
            }
          })
          .fromTo(
            '.phrase-js',
            {
              autoAlpha: 1
            },
            {
              autoAlpha: 0,
              duration: 0.2
            },
            0.1
          )
          .fromTo(
            '.cyan-logo-p-js',
            {
              autoAlpha: 1
            },
            {
              autoAlpha: 0,
              xPercent: -160,
              yPercent: 40,
              duration: 0.3
            },
            0
          )
          .fromTo(
            '.cyan-logo-o-js',
            {
              autoAlpha: 1
            },
            {
              autoAlpha: 0,
              xPercent: -120,
              yPercent: 30,
              duration: 0.2
            },
            0.1
          )
          .fromTo(
            '.cyan-logo-h-js',
            {
              xPercent: 0
            },
            {
              xPercent: 0
            },
            0.2
          );
      } else {
        const tl = gsap
          .timeline({
            scrollTrigger: {
              trigger: section.current,
              start: 'top top',
              end: 'bottom bottom',
              scrub: true
            }
          })
          .fromTo(
            '.phrase-js',
            {
              autoAlpha: 1
            },
            {
              autoAlpha: 0,
              duration: 0.2
            },
            0.1
          )
          .fromTo(
            '.cyan-logo-p-js',
            {
              autoAlpha: 1
            },
            {
              autoAlpha: 0,
              xPercent: -160,
              yPercent: 40,
              duration: 0.3
            },
            0
          )
          .fromTo(
            '.cyan-logo-o-js',
            {
              autoAlpha: 1
            },
            {
              autoAlpha: 0,
              xPercent: -120,
              yPercent: 30,
              duration: 0.2
            },
            0.1
          )
          .fromTo(
            '.cyan-logo-h-js',
            {
              xPercent: 0
            },
            {
              xPercent: isMobile ? -100 : -300
            },
            0.2
          );
      }
    }, section.current);

    return () => {
      ctx.revert();
    };
  }, [isMobile]);

  return (
    <section ref={section} className="relative w-full h-[200dvh]">
      <div className="sticky top-0">
        <div className="pt-[30dvh] pb-[66dvh] sm:pb-[37dvh] lg:pb-[47dvh] xl:pb-[37dvh]">
          <div className="flex items-center justify-center w-full h-full">
            <div className="mr-10 sm:mr-30">
              <h2 className="title-2 !text-24 sm:!text-48 text-cyan-dark phrase-js">
                Simple, rápido,
              </h2>
            </div>
            <div className="relative w-140 sm:w-[41rem] h-60 sm:h-210">
              <div className="absolute top-[-24%] right-[17%] sm:top-[-19%] sm:right-[-1%] h-fit cyan-logo-p-js">
                <Image
                  src="/images/conocenos/p.svg"
                  width={149}
                  height={193}
                  alt=""
                  className="w-40 sm:w-[14.9rem] h-auto"
                />
              </div>
              <div className="absolute top-[-11%] left-[25%] sm:top-[-8%] sm:left-[32%] h-fit cyan-logo-o-js">
                <Image
                  src="/images/conocenos/o.svg"
                  width={181}
                  height={190}
                  alt=""
                  className="w-50 sm:w-[18.1rem] h-auto"
                />
              </div>
              <div className="absolute h-fit cyan-logo-h-js">
                <Image
                  src="/images/conocenos/h.svg"
                  width={174}
                  height={238}
                  alt=""
                  className="w-45 sm:w-[17.4rem] h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full relative pt-[30dvh] pb-[20dvh]">
        <div className="site-grid">
          <div className="col-span-4 lg:col-start-4 sm:col-span-8 sm:pl-40">
            <div className="mb-65 opacity-90">
              <Volanta label="¿Quiénes somos?" />
            </div>
            <div>
              <h3 className="title-3 text-cyan-dark">
                  { description }
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default SomosDesktop;
